/** 趋势分析比较得分：各维度在当日勾选子板块内 Min-Max 归一化后加权求和（可跨父板块）。 */

const SCORE_WEIGHTS = {
  资金强度: 40,
  资金密度: 40,
  红盘覆盖率: 10,
  板块情绪强度: 10,
  情绪溢价率: 10,
  大资金封单纯度: 10,
  市场共识强度: 10
};

const METRIC_API_KEYS = {
  fundStrength: '资金强度',
  fundDensity: '资金密度',
  redPlateCoverage: '红盘覆盖率',
  plateSentimentStrength: '板块情绪强度',
  sentimentPremiumRate: '情绪溢价率',
  largeSealPurity: '大资金封单纯度',
  marketConsensusStrength: '市场共识强度'
};

function normalizeDimension(value, minVal, maxVal) {
  if (value == null || minVal == null || maxVal == null) return null;
  const denom = Number(maxVal) - Number(minVal);
  if (denom === 0) return 0;
  return (Number(value) - Number(minVal)) / denom;
}

function computeWeightedScore(metrics) {
  let score = 0;
  let hasAny = false;
  Object.entries(SCORE_WEIGHTS).forEach(([key, weight]) => {
    const val = metrics[key];
    if (val != null) {
      score += Number(val) * weight;
      hasAny = true;
    }
  });
  return hasAny ? Math.round(score * 10000) / 10000 : null;
}

/**
 * 按 tradeDate 分组，对同组内行做 7 维 Min-Max 归一化并写入 compareScore。
 * 调用方应传入同一批勾选子板块的每日明细（可跨父板块）。
 * @param {Array<object>} rows
 * @returns {Array<object>}
 */
export function applyCompareScores(rows) {
  if (!rows || !rows.length) return rows;

  const fields = Object.entries(METRIC_API_KEYS);
  const byDate = {};

  rows.forEach((row) => {
    const tradeDate = row.tradeDate;
    if (!tradeDate) return;
    const key = String(tradeDate);
    if (!byDate[key]) byDate[key] = [];
    byDate[key].push(row);
  });

  Object.values(byDate).forEach((dayRows) => {
    const mins = {};
    const maxs = {};

    fields.forEach(([field, chineseKey]) => {
      const vals = dayRows.map((r) => r[field]).filter((v) => v != null);
      if (!vals.length) {
        mins[chineseKey] = null;
        maxs[chineseKey] = null;
        return;
      }
      mins[chineseKey] = Math.min(...vals.map(Number));
      maxs[chineseKey] = Math.max(...vals.map(Number));
    });

    dayRows.forEach((row) => {
      const normalized = {};
      fields.forEach(([field, chineseKey]) => {
        normalized[chineseKey] = normalizeDimension(
          row[field],
          mins[chineseKey],
          maxs[chineseKey]
        );
      });
      row.compareScore = computeWeightedScore(normalized);
    });
  });

  return rows;
}

export function avgMetric(values) {
  const nums = values.filter((v) => v != null).map(Number);
  if (!nums.length) return null;
  const sum = nums.reduce((a, b) => a + b, 0);
  return Math.round((sum / nums.length) * 10000) / 10000;
}
